import { render, staticRenderFns } from "./InstitutionalAllocation.vue?vue&type=template&id=7b04b3ae&scoped=true"
import script from "./InstitutionalAllocation.vue?vue&type=script&lang=js"
export * from "./InstitutionalAllocation.vue?vue&type=script&lang=js"
import style0 from "./InstitutionalAllocation.vue?vue&type=style&index=0&id=7b04b3ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b04b3ae",
  null
  
)

export default component.exports